<script lang="ts">
	import { _ } from 'svelte-i18n';
	import { CalcoloEmissioniOutput } from "../../../models/PSCL/Schema/PSCLSchemaProgettazione";
	import { formatNumberWithSeparators } from '../../../functions';
	
	export let data: CalcoloEmissioniOutput = new CalcoloEmissioniOutput();
</script>
<table class="w-full text-xs border border-black table-fixed">
    <thead>
		<tr>
			<th class="border border-black">Modalità</th>
			<th class="border border-black">NOx</th>
			<th class="border border-black">PM10</th>
			<th class="border border-black">CO2</th>
		</tr>
    </thead>
    <tbody>
		{#if data?.modalitaReportEmissioni?.length > 0}
			{#each data.modalitaReportEmissioni as modalita}
				<tr>
					<td class="text-center border border-black">{modalita?.modalita}</td>
					<td class="text-center border border-black">{formatNumberWithSeparators(modalita?.nOx)}</td>
					<td class="text-center border border-black">{formatNumberWithSeparators(modalita?.pM10)}</td>
					<td class="text-center border border-black">{formatNumberWithSeparators(modalita?.cO2)}</td>
				</tr>
			{/each}
		{:else}
			<tr>
				<td class="text-center border-black text-centerborder">Bicicletta</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Trasporto pubblico</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Car pooling</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Car sharing</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Scooter sharing</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Bike sharing</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Monopattini in sharing</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Smart working</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Navette</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
			<tr>
				<td class="text-center border border-black">Piedi</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
				<td class="text-center bg-blue-100 border border-black">-</td>
			</tr>
		{/if}
    </tbody>
    <tfoot>
		<tr>
			<td class="text-right border border-white border-r-black" colspan="1">Benefici ambientali [kg/anno] </td>
			<td class:bg-blue-100={!data?.totaleNOx} class="text-center border border-black">{formatNumberWithSeparators(data?.totaleNOx) || ''}</td>
			<td class:bg-blue-100={!data?.totalePM10} class="text-center border border-black">{formatNumberWithSeparators(data?.totalePM10) || ''}</td>
			<td class:bg-blue-100={!data?.totaleCO2} class="text-center border border-black">{formatNumberWithSeparators(data?.totaleCO2) || ''}</td>
		</tr>
	</tfoot>
</table>